import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Box, Grid } from "@mui/material";
import { memo, useMemo } from "react";
import { automationParamList } from "../../../../../../../services/automationParam";
import { RuleParamIf } from "./RuleParamIf";
import { RuleParamThen } from "./RuleParamThen";
import { useTranslation } from "react-i18next";
import { IIntegrationRuleParamFieldsProps } from "./models";
import { TIntegrationRuleParamForm } from "./integrationRuleParamSchema";
import { useWatch } from "react-hook-form";

const translationPath = "page.4uBus.integrationRule.integrationRuleParam.";

export const IntegrationRuleParamFields = memo(
  ({ busAutomationCode }: IIntegrationRuleParamFieldsProps) => {
    const { t } = useTranslation();

    const { control, setValue } = useFormContext<TIntegrationRuleParamForm>();

    const uBusAutomationParam = useWatch({
      control,
      name: "uBusAutomationParam",
    });

    const uBusAutomationParamParams = useMemo(
      () => ({
        _4uBusAutomationCode: busAutomationCode,
      }),
      [busAutomationCode],
    );

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AutoComplete
              request={automationParamList}
              params={uBusAutomationParamParams}
              getOptionLabel={({ name }) => name}
              name="uBusAutomationParam"
              size="small"
              label={t(translationPath + "inclusion_rule_type")}
              onValueChange={() => {
                setValue("ifOneName", "");
                setValue("ifOneCode", "");
                setValue("ifTwoName", "");
                setValue("ifTwoCode", "");
                setValue("ifThreeName", "");
                setValue("ifThreeCode", "");
                setValue("ifFourName", "");
                setValue("ifFourCode", "");
                setValue("thenOneName", "");
                setValue("thenOneCode", "");
                setValue("thenTwoName", "");
                setValue("thenTwoCode", "");
                setValue("thenThreeName", "");
                setValue("thenThreeCode", "");
                setValue("thenFourName", "");
                setValue("thenFourCode", "");
              }}
            />
          </Grid>
        </Grid>

        {uBusAutomationParam && (
          <Box pl={2}>
            <RuleParamIf
              uBusAutomationParam={uBusAutomationParam}
              busAutomationCode={busAutomationCode}
            />

            <RuleParamThen
              uBusAutomationParam={uBusAutomationParam}
              busAutomationCode={busAutomationCode}
            />
          </Box>
        )}
      </>
    );
  },
);
